import { configureStore } from "@reduxjs/toolkit";
import designerReducer from './slices/designerSlice';
import inspectorReducer from './slices/inspectorSlice';

const store = configureStore({
  reducer: {
    designer: designerReducer,
    inspector: inspectorReducer,
  },
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;